import React, { useState } from "react";
import CommonForm from "../../../components/common/LoginForm/CommonForm";
import { useFormik } from "formik";
import * as Yup from "yup";
import EmailIcon from "@mui/icons-material/Email";
import loginimg from "../../../assest/image/loginbkg.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { handleForgotApi } from "../../../redux/action/AuthAction";
import { authSelector } from "../../../redux/slices/authSlice";

export default function ForgotPage() {
  // State to handle loading spinner and multiple organization check
  const [isloading, setIsLoading] = useState(false);
  const [multiOrg, setMultiorg] = useState(false);

  // Holds selected organization name
  const [selectedDateLabel, setSelectedDateLabel] = React.useState("");

  // Redux selector to access organization data
  const { organizationsData } = useSelector(authSelector);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Formik setup for handling form state and validation
  const formikreset = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("email is required"),
    }),
    onSubmit: (values) => {
      setIsLoading(true);

      // Prepare payload and trigger forgot password API
      const body = { email: values?.email, organization: selectedDateLabel };
      dispatch(handleForgotApi(setIsLoading, body, navigate, setMultiorg));
    },
  });

  // When user selects an organization, update state
  const handleChange = (event) => {
    const selectedId = event.target.value;
    const selectedOption = organizationsData.find(
      (opt) => opt.id === selectedId
    );
    setSelectedDateLabel(selectedOption?.name);
  };

  // Form config when only email input is required
  const Resetform = {
    title: "Verify mail",
    onsubmit: formikreset.handleSubmit,
    loader: isloading,
    btnText: "Verify",
    onClick: formikreset.handleSubmit,
    backpath: "/",
    inputGroups: [
      {
        type: "email",
        placeholder: "Enter mail",
        name: "email",
        onChange: formikreset?.handleChange,
        icon: <EmailIcon />,
        value: formikreset.values.email,
        error: formikreset.errors.email,
        touched: formikreset.touched.email,
        fieldtype: false,
      },
    ],
  };

  // Form config when email and organization selection is required
  const Resetform1 = {
    title: "Select Organization",
    onsubmit: formikreset.handleSubmit,
    loader: isloading,
    btnText: "Continue",
    onClick: formikreset.handleSubmit,
    backpath: "/",
    inputGroups: [
      {
        type: "email",
        placeholder: "Enter mail",
        name: "email",
        onChange: formikreset?.handleChange,
        icon: <EmailIcon />,
        value: formikreset.values.email,
        error: formikreset.errors.email,
        touched: formikreset.touched.email,
        fieldtype: true,
        organization: selectedDateLabel,
        handleChange: handleChange,
        orgData: organizationsData,
      },
    ],
  };

  return (
    <div className="login-container">
      {/* Conditionally render organization selection form or email-only form */}
      {multiOrg ? (
        <div className="login-form-container">{CommonForm(Resetform1)}</div>
      ) : (
        <div className="login-form-container">{CommonForm(Resetform)}</div>
      )}

      {/* Right-side background/login image */}
      <div className="login-image-container">
        <img className="robot-image" alt="img" src={loginimg} />
      </div>
    </div>
  );
}
